import Axios from "../Axios";

const SUBJECT_API_URL = "/subjects";

class SubjectService {
  async getSubjects(filters = {}) {
    const params = {
      dashboard: 1,
      include: 'academicYear,teachers', // Include the academicYear and teachers relationships
      ...filters, // Include any filters passed to the method
    };
    const response = await Axios.get(SUBJECT_API_URL, {
      params: params,
    });
    return response.data.data;
  }

  async getSubject(id) {
    const response = await Axios.get(`${SUBJECT_API_URL}/${id}`, {
      params: {
        include: 'academicYear,teachers.country', // Detail pages need descriptions plus teacher country data
      },
    });
    return response.data.data;
  }

  async createSubject(subject) {
    // Check if subject is FormData (for file uploads)
    const isFormData = subject instanceof FormData;
    
    const response = await Axios.post(SUBJECT_API_URL, subject, {
      headers: isFormData ? {
        'Content-Type': 'multipart/form-data',
      } : {}
    });
    return response.data.data;
  }

  async updateSubject(id, subject) {
    // Check if subject is FormData (for file uploads)
    const isFormData = subject instanceof FormData;
    
    if (isFormData) {
      // Use POST with _method=PUT for FormData
      const response = await Axios.post(`${SUBJECT_API_URL}/${id}`, subject, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data.data;
    } else {
      // Use regular PUT for JSON data
      const response = await Axios.put(`${SUBJECT_API_URL}/${id}`, subject);
      return response.data.data;
    }
  }

  async deleteSubject(id) {
    const response = await Axios.delete(`${SUBJECT_API_URL}/${id}`);
    return response.data;
  }

  async attachTeachersToSubject(subjectId, teacherIds) {
      const response = await Axios.post(`${SUBJECT_API_URL}/${subjectId}/teachers/attach`, {
        teacher_ids: teacherIds,
    });
    return response.data;
  }

  async detachTeachersFromSubject(subjectId, teacherIds) {
      const response = await Axios.post(`${SUBJECT_API_URL}/${subjectId}/teachers/detach`, {
        teacher_ids: teacherIds,
    });
    return response.data;
  }
}

export default new SubjectService();
